import { defineNuxtPlugin, useRouter } from "#app";
import { useRequestURL } from "#app/composables/url";

import {
  addCurrentPageEvent,
  addMarketingParamsGtmEvent,
  addPageViewGtmEvent,
  initInteractionTracking,
} from "@solvari/argus";
import { initArgus } from "@solvari/argus/service";
import { startUserDataGtmWatcher } from "@solvari/common-fe/composables";
import { resolveClientId } from "@solvari/utils";

export default defineNuxtPlugin(() => {
  const clientId = resolveClientId();
  initArgus(clientId);
  const router = useRouter();
  const { origin } = useRequestURL();
  void addMarketingParamsGtmEvent();
  initInteractionTracking();

  startUserDataGtmWatcher();

  router.afterEach((_to, from) => {
    if (!from.matched.length) {
      return;
    }

    void addCurrentPageEvent();
    void addPageViewGtmEvent(origin + from.fullPath);
  });
});
